<template>
  <div
    style="
      background: #2b0000;
      min-height: 100vh;
      height: auto;
      background-size: cover;
    "
    class="pt-5"
  >
    <!-- <img
              class="mx-auto mb-4"
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/shwe-ohh/general/logo%20png%20(1).png"
              alt=""
              @click="$router.push('/home')"
              style="height: 6rem"
            />
             -->
    <div
      class="col-11 mx-auto card border-0 mb-0 auth-card mt-5"
      style="
        background: #590007;
        box-shadow: none !important;
        border-radius: 7px !important;
      "
    >
      <!-- <img
                    class="mx-auto my-3"
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/shwe-ohh/general/logo%20typo%20png_1%20(1).png"
                    alt=""
                    @click="$router.push('/home')"
                    style="width: 20rem; height: auto"
                /> -->

      <div class="card-body px-lg-7 py-lg-7">
        <div class="text-center text-muted mb-4 text-white">
          <!-- <h3 _ngcontent-dpt-c65="" class="text-white text-center text-sm">
            OTP ကုဒ်ကို SMS မှတစ်ဆင့် သင့်ဖုန်းနံပါတ် <br /><span
              class="text-danger text-lg"
              style="color: #d5c298 !important"
              >{{ phone }}</span
            >
            သို့ ပေးပို့ပြီးပါပြီ။
          </h3> -->

          <h3 _ngcontent-dpt-c65="" class="text-white text-center text-sm">
            မိမိကြိုက်နှစ်သက်ရာ ဂဏန်းခြောက်လုံး ရိုက်ထည့်ပေးပါ။
          </h3> -->

          

          <div class="error text-white d-flex" v-if="error">
            <span class="mx-auto">
              {{ error }}
            </span>
          </div>
        </div>
        <form role="form">
          <small class="text-danger">{{ errors.code }}</small>
          <div class="form-group">
            <van-password-input
              :value="code"
              :mask="false"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
              theme="dark"
            />
            <VueNumericKeypad
              v-if="isDesktop"
              :value.sync="code"
              :show.sync="showKeyboard"
              :options="options"
              :buttonClass="'keypad-button'"
            />
            <van-number-keyboard
              v-else
              v-model="code"
              :maxlength="6"
              :show="showKeyboard"
              @blur="showKeyboard = false"
              theme="dark"
            />
          </div>
          <div class="text-center mt-3 d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-success my-4 mx-auto"
              style="
                background: linear-gradient(
                  to bottom,
                  #ffc500 0%,
                  #ff4500 50%,
                  #c71600 100%
                );
                color: white;
                border-radius: 0.5rem;
                width: 15rem;
                box-shadow: none;
              "
              @click="verifyCode"
            >
              <div v-if="!isVerifying">
                {{ $store.state.language === "en" ? "Confirm" : "အတည်ပြုမည်။" }}
              </div>

              <Loading
                color="#ffffff"
                v-if="isVerifying"
                size="24"
                class="px-4 py-0"
              />
            </button>
            <div class="mx-4"></div>
            <van-count-down
              class="pt-2"
              v-if="userByPhone.otp_resend_expired_at > 0"
              :time="userByPhone.otp_resend_expired_at"
              @finish="finishCountdown"
            >
              <template #default="timeData">
                <span class="block">{{ timeData.minutes }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>

            <button
              type="button"
              class="btn btn-dark my-4"
              style="
                background: #fff;
                color: black;
                border-radius: 0.5rem;
                width: 15rem;
                box-shadow: none;
              "
              @click="isResend ? '' : resendCode()"
              v-if="userByPhone.otp_resend_expired_at === 0"
            >
              <div v-if="!isResend">
                {{
                  $store.state.language === "en"
                    ? "Resend Code"
                    : "Code ပြန်ပို့ပေးပါ။"
                }}
              </div>
              <Loading color="#000" size="24" class="px-4 py-0" v-else />
            </button>
          </div>
          <!-- <div class="col-6">
                            <a @click="logout" class="new-account-text"
                                ><b>{{
                                    $store.state.language === "en"
                                        ? "Re-create account"
                                        : "အကောင့်ပြန်ဖွင့်မည်။"
                                }}</b></a
                            >
                        </div> -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from "vant";
import { mapActions } from "vuex";
import VueNumericKeypad from "vue-numeric-keypad";

export default {
  components: { Loading, VueNumericKeypad },
  data() {
    return {
      code: "",
      error: false,
      errors: {},
      isVerifying: false,
      isResend: false,
      showKeyboard: true,
      phone: null,
      userByPhone: {
        otp_resend_expired_at: null,
      },
      options: {
        fixDeleteKey: false,
        keyRandomize: false,
        keyArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, "", 0, -1],
      },
    };
  },
  computed: {
    isDesktop() {
      return window.outerWidth > 768;
    },
  },
  methods: {
    finishCountdown() {
      console.log("success");
      this.fetchUserByPhone(this.phone);
    },
    ...mapActions(["fetchUser"]),
    logout() {
      try {
        this.$auth.logout({
          redirect: "/auth/register",
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleKey(e) {
      const isNumber = /^[0-9]$/.test(e.key);
      if (isNumber && this.verifyCode.length < 6) {
        this.code += e.key;
      } else if (e.key === "Backspace" || e.key === "Delete") {
        this.code = this.code.slice(0, -1);
      }
    },
    async verifyCode() {
      this.isVerifying = true;
      this.error = false;
      if (!this.code) {
        this.error =
          this.$store.state.language === "en"
            ? "Required Code"
            : "Code လိုအပ်ပါသည်။";
        this.isVerifying = false;
        return false;
      }
      if (this.code && this.code.length < 6) {
        this.error =
          this.$store.state.language === "en"
            ? "Code must be 6 characters"
            : "Code သည် 6 လုံးဖြစ်ရမည်။";
        this.isVerifying = false;
        return false;
      }
      try {
        const res = await axios.post("/auth/verify-code", {
          two_factor_code: this.code,
          phone: this.phone,
        });
        Toast.success(
          this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။"
        );
        this.$router.push("/auth/register");
        localStorage.setItem("token", res.data.token);
        this.error = false;
        this.isVerifying = false;
      } catch (err) {
        this.error =
          this.$store.state.language === "en"
            ? "Code Not Match"
            : "Code မမှန်ပါ။";
      }
      this.isVerifying = false;
      return true;
    },

    async resendCode() {
      this.isResend = true;
      try {
        const userData = {
          phone: this.phone,
        };

        const res = await this.axios.post("/auth/sms-otp-sending", {
          ...userData,
        });
        Toast.success(
          this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။"
        );
        this.fetchUserByPhone(this.phone);
      } catch (err) {
        console.log(err);
      }
      this.isResend = false;
      return true;
    },
    async fetchUserByPhone(phone) {
      try {
        const res = await this.axios.post("/get-tmp-user", {
          phone: phone,
        });
        this.userByPhone = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    // if (!authUser) {
    //   this.$router.push('/auth/login');
    // }
    // if (authUser && authUser.is_verified) {
    //   this.$router.push('/home');
    // }

    this.phone = localStorage.getItem("pendingPhone");
    this.fetchUserByPhone(this.phone);
    if (this.isDesktop) {
      window.addEventListener("keydown", this.handleKey);
    }
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKey);
  },
};
</script>

<style scoped>
/* Change placeholder text color for all input elements */
::placeholder {
  color: #2c2b2b; /* Light gray color */
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}
.new-account-text {
  cursor: pointer;
}
.error {
  margin-bottom: 13px;
  margin-top: 13px;
  height: 30px;
  display: flex;
  align-items: center;
  color: white;
  border: 1px solid red;
  border-radius: 8px;
  padding: 0px 15px;
  background: #ff000014;
  font-weight: bold;
}
.auth-card {
  background: #f7fafc;
}

.colon {
  display: inline-block;
  margin: 0 4px;
  color: #1989fa;
}
.block {
  display: inline-block;
  width: 22px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #1989fa;
  border-radius: 4px;
}

:deep(.numeric-keypad__button) {
  background-color: white;
  border: none;
  height: 48px;
  font-size: 20px;
  line-height: 1.5;
}

.numeric-keypad {
  background-color: #f2f3f5;
  border-radius: 0px;
  padding: 6px;
  height: 35vh;
  gap: 5px;
  padding-bottom: 20px;
}
</style>
